import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4fb28186&"
import script from "./zCamera.js?vue&type=script&lang=js&"
export * from "./zCamera.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4fb28186&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports